export const LOADED_ANNOUNCEMENTS = 'LOADED_ANNOUNCEMENTS';
export const LOADING_ANNOUNCEMENTS = 'LOADING_ANNOUNCEMENTS';

export interface LoadingAnnouncements {
  type: typeof LOADING_ANNOUNCEMENTS;
}
export interface LoadedAnnouncements {
  type: typeof LOADED_ANNOUNCEMENTS;
  payload: AnnouncementCollectionViewModel;
}
export type AnnouncementActionTypes =
  | LoadedAnnouncements
  | LoadingAnnouncements;

export interface AnnouncementViewModel {
  formattedText: string | null;
  plainText: string | null;
  canDismiss: boolean;
}

export interface AnnouncementCollectionViewModel {
  globalAnnouncements: AnnouncementViewModel[];
  myEcriAnnouncement: AnnouncementViewModel | null;
}

export interface AnnouncementState extends AnnouncementCollectionViewModel {
  loading: boolean;
  loaded: boolean;
}
